import { connect } from 'react-redux'

import { fetchNoteActivities } from 'data/noteActivities/actions'
import { selectors as UISelectors } from 'data/ui'
import { trackOpenComments } from 'data/analytics/actions'

export default connect(
  state => ({
    threadId: UISelectors.getActiveThreadId(state),
  }),
  {
    trackOpenComments,
    fetchNoteActivities,
  }
)
